import { useState, useEffect, useRef } from "react";
import "./generalservices.css";
import service1 from "../../images/working/register.png";
import service2 from "../../images/working/order.png";
import service3 from "../../images/working/install.png";
import service4 from "../../images/working/login.PNG";
import service5 from "../../images/working/location.png";
import service6 from "../../images/working/settings.png";

const services = [
  [
    { image: service1, title: "Create an Account", step: 1 },
    { image: service2, title: "Fill the Order Form", step: 2 },
    { image: service3, title: "Installation", step: 3 },
  ],
  [
    { image: service4, title: "Login to Your Account", step: 4 },
    { image: service5, title: "Track Your Vehicle", step: 5 },
    { image: service6, title: "Customize Settings", step: 6 },
  ],
];
const delay = 8000;

export default function Servicetwo() {
  const [index, setIndex] = useState(0);
  const timeoutRef = useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () => setIndex((prev) => (prev === services.length - 1 ? 0 : prev + 1)),
      delay
    );

    return () => resetTimeout();
  }, [index]);

  return (
    <div className="slideshow-container">
      <h2 className="section-title">How It Works</h2>
      <div className="slideshow-wrapper">
        {services.map((group, idx) => (
          <div
            key={idx}
            className={`slide ${index === idx ? "active" : ""}`}
          >
            {group.map((item, i) => (
              <div className="service-card" key={i}>
                <img src={item.image} alt={item.title} className="service-image" />
                <div className="service-info">
                  <h3>{item.title}</h3>
                  <span className="step-number">Step {item.step}</span>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className="dots">
        {services.map((_, idx) => (
          <span
            key={idx}
            className={`dot ${index === idx ? "active" : ""}`}
            onClick={() => setIndex(idx)}
          ></span>
        ))}
      </div>
    </div>
  );
}
